{
"formElements": {
    "formRows": [
        {
            "formGroups": [
                {
                    "style": {
                    "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "code",
                        "displayLabel": "Service Code",
                        "disabled": false,
                        "placeHolder": "Enter Service Code",
                        "fieldInfo": {
                            "dataType": "text"
                        },
                        "validators": [
                            {
                            "type": "required",
                            "message": "Service Code is required"
                            }
                        ]
                    }
                },
                {
                    "style": {
                        "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "name",
                        "displayLabel": "Service Name",
                        "disabled": false,
                        "placeHolder": "Enter Service Name",
                        "fieldInfo": {
                            "dataType": "text"
                        },
                        "validators": [
                            {
                            "type": "required",
                            "message": "Service Name is required"
                            }
                        ]
                    }
                },
                {
                    "style": {
                    "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "description",
                        "displayLabel": "Description",
                        "disabled": false,
                        "placeHolder": "Enter Description",
                        "fieldInfo": {
                            "dataType": "textarea"
                        }
                    }
                }
            ]
        },
        {
            "formGroups": [
                {
                    "style": {
                    "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "serviceType",
                        "displayLabel": "Service Type",
                        "disabled": false,
                        "placeHolder": "Select Service Type",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": [
                                {
                                    "label": "General Service",
                                    "value": "GENERAL_SERVICE"
                                },
                                {
                                    "label": "Special Service",
                                    "value": "SPECIAL_SERVICE"
                                }
                            ]
                        },
                        "validators": [
                            {
                            "type": "required",
                            "message": "Service Type is required"
                            }
                        ]
                    }
                },
                {
                    "style": {
                    "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "entityType",
                        "displayLabel": "Entity Type",
                        "disabled": false,
                        "placeHolder": "Select Entity Type",
                        "fieldInfo": {
                            "dataType": "select",
                            "options": [
                                {
                                    "label": "Cargo",
                                    "value": "CARGO"
                                },
                                {
                                    "label": "Container",
                                    "value": "CONTAINER"
                                }
                            ]
                        },
                        "validators": [
                            {
                            "type": "required",
                            "message": "Entity Type is required"
                            }
                        ]
                    }
                },
                {
                    "style": {
                    "gridColumn": "span 3"
                    },
                    "control": {
                        "label": "active",
                        "skipLabel": true,
                        "displayLabel": "Active",
                        "defaultValue": true, 
                        "disabled": false,
                        "fieldInfo": {
                            "dataType": "boolean"
                        }
                    }
                }
            ]
        }
    ]
  },
  "tableHeaders": [
      {
        "fieldName": "equipmentName",
        "displayName": "Equipment Name"
      },
      {
        "fieldName": "active",
        "displayName": "Active"
      }
    ],
    "attributeTableMeta": {
        "name": "Attribute",
        "columns": [
        {
            "fieldName": "name",
            "displayName": "Attribute Name",
            "dataType": "STRING",
            "thStyleConfig": {
                "width": "100px"
            }
        },
        {
            "fieldName": "symbol",
            "displayName": "Symbol",
            "dataType": "STRING",
            "thStyleConfig": {
                "width": "100px"
            }
        },
        {
            "fieldName": "description",
            "displayName": "Description",
            "dataType": "STRING",
            "thStyleConfig": {
                "width": "200px"
            }
        },
        {
            "fieldName": "dataType",
            "displayName": "Attribute Type",
            "dataType": "STRING",
            "valueMap": {
                "STRING": "String",
                "BIGDECIMAL": "Number",
                "BOOLEAN": "Boolean"
            },
            "thStyleConfig": {
                "width": "100px"
            }
        },
        {
            "fieldName": "mandatory",
            "displayName": "Mandatory",
            "dataType": "BOOLEAN",
            "thStyleConfig": {
            "width": "100px"
            }
        },
        {
            "fieldName": "defaultValueDisplay",
            "displayName": "Default Value",
            "dataType": "STRING",
            "thStyleConfig": {
            "width": "100px"
            }
        }
    ]
  }
}